// extracted by mini-css-extract-plugin
export var activeFilterButton = "_n9-c";
export var backButton = "_n9-4";
export var backIcon = "_n9-5";
export var chevronShortcut = "_n9-6";
export var container = "_n9-1";
export var editor = "_n9-8";
export var editorWrapper = "_n9-7";
export var prefix = "_n9-2";
export var searchIcon = "_n9-3";
export var suffix = "_n9-9";
export var suffixContent = "_n9-a";
export var suffixText = "_n9-b";
export var wrapper = "_n9-0";